import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
});

let refreshing = null;
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  if (error.response?.status !== 401 || !cfg || cfg._retried || cfg.url?.startsWith("/auth/")) throw error;
  cfg._retried = true;
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  await refreshing;
  return api(cfg);
});

const PARAM_MAP = {
  from: "date_from", to: "date_to", platform: "platform", provider: "provider", game: "game",
  device: "device", event_type: "event_type", campaign: "campaign", source: "source",
};

// Convert a filter object into query params, omitting empty values.
export function buildParams(filter = {}) {
  const p = {};
  Object.entries(PARAM_MAP).forEach(([k, q]) => { if (filter[k]) p[q] = filter[k]; });
  return p;
}

const PT = [
  [/Input should be greater than or equal to (\S+)/, "O valor deve ser maior ou igual a $1."],
  [/Input should be less than or equal to (\S+)/, "O valor deve ser menor ou igual a $1."],
  [/Input should be a valid integer.*/, "Informe um número inteiro."],
  [/String should have at most (\d+) characters?/, "Use no máximo $1 caracteres."],
  [/String should have at least (\d+) characters?/, "Use pelo menos $1 caracteres."],
  [/Field required/, "Campo obrigatório."],
];
const translate = (m) => PT.reduce((acc, [re, rep]) => acc.replace(re, rep), m);

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => translate((x?.msg || JSON.stringify(x)).replace(/^Value error, /, ""))).join(" ");
  if (!e?.response) return "Sem conexão com o servidor. Verifique a rede e tente novamente.";
  return e?.message || "Erro inesperado";
}
